export function parseResponseData<T>(data: unknown): T {
    if (typeof data === 'string') {
        return JSON.parse(data) as T;
    }

    return data as T;
}

export function getStatusVariant(status: string): 'success' | 'danger' | 'secondary' {
    if (status === 'success' || status === 'complete') {
        return 'success';
    }

    if (status === 'failed') {
        return 'danger';
    }

    return 'secondary';
}

export function getImageName(imageS3Key: string): string {
    return imageS3Key.split('/').filter(Boolean).pop() || imageS3Key;
}
